import { EntityType } from "@/core/types";
import { JobRequestPageable } from "@/data/job-requests/types/JobRequestPageable";

import { useRelatedEntitiesQuery } from "./useRelatedEntitiesQuery";

interface UseRelatedJobRequestsQueryParams {
  entityType: EntityType;
  entityId: string | number;
  url: string;
}

export const useRelatedJobRequestsQuery = (params: UseRelatedJobRequestsQueryParams) => {
  return useRelatedEntitiesQuery({
    ...params,
    relatedEntityKey: "job-request",
    resultType: JobRequestPageable,
  });
};
